import React from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ExportCsv } from '../../core/ExportData/ExportCsv';
import { ExportXlsx } from '../../core/ExportData/ExportXlsx';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

interface Props {
  headers: HeaderItem[];
  items: Item[];
  isSameDay: boolean;
  exportOptions?: any;
}
interface Item {
  label: string;
  data: string[];
  isPlan?: boolean;
}

interface HeaderItem {
  label: string;
  tooltip: string;
}

const useStyles: any = makeStyles({
  table: {
    minWidth: 450,
  },
  topDivider: {
    borderTop: '2px solid black !important',
  },
  botDivider: {
    borderBottom: '1px solid !important',
  },
  leftSumDivider: {
    borderLeft: '1px solid !important',
  },
  leftFirstSumDivider: {
    borderLeft: '1px solid !important',
    borderBottom: '1px solid !important',
  },
});

export function DashboardTable({ headers, items, isSameDay, exportOptions }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const classes = useStyles();
  const headersCells = headers.map((item, i) => {
    return (
      <TableCell component="th" key={i} sx={{ lineHeight: isSameDay ? 1 : 0, paddingBottom: 0 }}>
        <Tooltip title={item.tooltip}>
          <Typography>{item.label}</Typography>
        </Tooltip>
      </TableCell>
    );
  });

  const itemsRows = items.map((item: any, i) => {
    return (
      <TableRow key={i}>
        <TableCell size={'small'}>
          <Typography noWrap>{item.label}</Typography>
        </TableCell>
        {item.data.map((value: any, i: number) => {
          return (
            <TableCell key={i} sx={item?.style} size={'small'}>
              {value ? value.toLocaleString() : '-'}
            </TableCell>
          );
        })}
        <TableCell key={i} sx={item?.style} size={'small'}>
          {item.sum.toLocaleString()}
        </TableCell>
      </TableRow>
    );
  });

  return (
    <>
      {exportOptions && (
        <>
          <Button
            id="demo-positioned-button"
            aria-controls={open ? 'demo-positioned-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            variant={'outlined'}
          >
            <FileDownloadIcon /> Export
          </Button>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem onClick={handleClose}>
              <ExportXlsx
                data={exportOptions.data}
                filterColumns={exportOptions.columns}
                fileName={exportOptions.fileName}
              />
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <ExportCsv
                data={exportOptions.data}
                filterColumns={exportOptions.columns}
                fileName={exportOptions.fileName}
              />
            </MenuItem>
          </Menu>
        </>
      )}
      <TableContainer
        sx={{
          maxWidth: 80 + 'vw',
          maxHeight: 70 + 'vh',
        }}
      >
        <Table className={classes.table} sx={{ minWidth: 500 }} stickyHeader={true}>
          <TableHead>
            <TableRow>
              <TableCell component="th" sx={{ lineHeight: isSameDay ? 1 : 0, paddingBottom: 0 }} />
              {headersCells}
              <TableCell component="th">
                <Typography
                  style={{ fontSize: '2em', lineHeight: isSameDay ? 1 : 0, paddingBottom: 0 }}
                >
                  Σ
                </Typography>
              </TableCell>
            </TableRow>
            {itemsRows}
          </TableHead>
        </Table>
      </TableContainer>
    </>
  );
}
